import { ref } from '@vue/composition-api';

// Смещение таймзоны сервера относительно UTC, в минутах.
// Устанавливается из Root.vue после загрузки getTimezoneShift.
// null — сдвиг ещё не загружен, convertDate использует таймзону браузера.
const serverTimezoneShift = ref(null);

export const setServerTimezoneShift = shift => {
  serverTimezoneShift.value = shift;
};

export const getServerTimezoneShift = () => serverTimezoneShift.value;

// Сдвигает метку на величину смещения таймзоны сервера, чтобы при
// форматировании в UTC получалось серверное время.
export const shiftToServerTime = date => {
  const shift = serverTimezoneShift.value;
  if (shift == null) {
    return new Date(date);
  }
  return new Date(new Date(date).getTime() + shift * 60 * 1000);
};

export const convertDate = date => {
  const shift = serverTimezoneShift.value;
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    // При известном сдвиге сервера форматируем сдвинутое значение как UTC,
    // что даёт серверное время; иначе — локальная таймзона браузера.
    timeZone: shift == null ? undefined : 'UTC'
  }).format(shiftToServerTime(date));
};

export const safeConvertDate = date => {
  try {
    return convertDate(date);
  } catch {
    return 'n/a';
  }
};
